module.exports = __webpack_public_path__ + "img/mp3.8ad22c37.svg";